import NGODashboardLayout from "layout/dashboardlayout/ngodashboardlayout.js";
import React, { useEffect, useState } from "react";
import Details from "./Details";
import { DONATIONTABLECOLUMN } from "utilities/data";
import Table from "shared/Table";
import { useDispatch, useSelector } from "react-redux";
import {
  getDonationPerNgo,
  totalDonationAmountPerNgo,
} from "appState/donation/donationSlice";

const NGODonationsLayout = () => {
  const { donations } = useSelector((state) => state.donation);
  const { ngoProfile } = useSelector((state) => state.auth);

  const [donationCurrent, setDonationCurrent] = useState(donations);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDonationPerNgo({ id: ngoProfile?.ngoProfile?.ngo?._id }));
    dispatch(totalDonationAmountPerNgo({ ngoId: ngoProfile?.ngoProfile?._id }));
  }, [dispatch, ngoProfile?.ngoProfile?._id, ngoProfile?.ngoProfile?.ngo?._id]);

  return (
    <NGODashboardLayout section="Donations" infoText="Manage your donations">
      <div className="bg-white rounded-md p-6 max-[450px]:p-3">
        <Details setDonationCurrent={setDonationCurrent} />
        <Table
          columns={DONATIONTABLECOLUMN}
          data={donationCurrent}
          selectableRows
          pagination
        />
      </div>
    </NGODashboardLayout>
  );
};

export default NGODonationsLayout;
